import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Loading } from "~/components/general";
import SingleSharedAsset from "~/containers/Assets/Shared/SingleSharedAsset";
import { useGetAssetByUuid, useGetAssetPartsByUuid } from "~/services/asset";

const MachineQRCode = () => {
  const { machineUuid: uuid } = useParams() as { machineUuid: string };
  const [assetRedirected, setAssetRedirected] = useState(false);
  const navigate = useNavigate();

  const { asset, loading } = useGetAssetByUuid({
    uuid,
  });
  const { assetParts, loading: assetPartsLoading } = useGetAssetPartsByUuid({
    uuid,
  });

  useEffect(() => {
    if (!asset && !loading) navigate("/oem");
    else if (asset && !loading) {
      if (asset.isOwnAsset) navigate(`/app/asset-hub/my-assets/${asset._id}`);
      else if (!asset.isQRCodeFlowEnabled) navigate("/error-page/404");
      else if (asset.isSharedAsset)
        navigate(
          `/app/asset-hub/shared/${asset.customer?._id}/assets/${asset._id}`,
        );
      setAssetRedirected(true);
    }
  }, [asset, assetParts, loading, assetPartsLoading]);

  if (loading || assetPartsLoading) return <Loading />;

  return assetRedirected ? (
    <SingleSharedAsset asset={asset} assetParts={assetParts} isQRCodeFlow />
  ) : null;
};

export default MachineQRCode;
